<div fxLayout="column">
  <div fxLayout="row" fxLayoutGap="16px">
    <wai-form-dropdown
      fxFlex="80px"
      label="{{ 'INTL_SALUTATION' | translate }}"
      [control]="asFormControl(form.controls.salutation)"
      [options]="salutations"
    >
    </wai-form-dropdown>
    <wai-form-dropdown
      fxFlex="80px"
      label="{{ 'INTL_TITLE' | translate }}"
      [control]="asFormControl(form.controls.title)"
      [options]="titles"
    >
    </wai-form-dropdown>
    <wai-form-input
      appearance="outline"
      fxFlex
      label="{{ 'INTL_FIRST_NAME' | translate }}"
      [control]="asFormControl(form.controls.firstName)"
    ></wai-form-input>
    <wai-form-input
      appearance="outline"
      fxFlex
      label="{{ 'INTL_LAST_NAME' | translate }}"
      [control]="asFormControl(form.controls.lastName)"
    ></wai-form-input>
  </div>

  <wai-form-input-yes-no icon="error" caption="{{ 'INTL_PEP' | translate }}:" [control]="asFormControl(form.controls.isPep)">
  </wai-form-input-yes-no>

  <wai-form-input
    appearance="outline"
    label="{{ 'INTL_EMAIL' | translate }}"
    prefixIcon="email"
    [control]="asFormControl(form.controls.email)"
  ></wai-form-input>

  <wai-form-input
    appearance="outline"
    label="{{ 'INTL_ADDRESS' | translate }}"
    prefixIcon="map"
    [control]="asFormControl(form.controls.address)"
  ></wai-form-input>

  <wai-form-input
    appearance="outline"
    fxFlex
    label="{{ 'INTL_PHONE' | translate }}"
    mask="phone"
    floatLabel="always"
    prefixIcon="phone"
    placeholder="+1234567890"
    [control]="asFormControl(form.controls.phone)"
  ></wai-form-input>

  <!-- Date of Birth and Percentage in Company for beneficial owners -->
  <div
    *ngIf="type === 'benef-owner' || form?.controls?.type?.value === 'benef-owner'"
    fxLayout="row"
    fxLayoutGap="16px"
    fxLayout.xs="column"
  >
    <div fxFlex>
      <wai-form-date-picker
        appearance="outline"
        label="{{ 'INTL_BIRTHDAY' | translate }}"
        [control]="asFormControl(form.controls.dateOfBirth)"
        [maxDate]="today"
      ></wai-form-date-picker>
    </div>
    <div fxFlex>
      <wai-form-input
        appearance="outline"
        label="{{ 'INTL_PERCENTAGE_IN_COMPANY' | translate }}"
        type="number"
        suffix="%"
        [control]="asFormControl(form.controls.percentageInCompany)"
      ></wai-form-input>
    </div>
  </div>

  <wai-form-dropdown
    appearance="outline"
    fxFlex
    label="{{ 'INTL_CURRENCY' | translate }}"
    [control]="asFormControl(form.controls.currency)"
    [options]="currencies"
  >
  </wai-form-dropdown>

  <div class="declarations-contacts-legal">
    <h2>{{ 'INTL_VERIFY_LEGAL_REPRESENTATIVE' | translate }}</h2>
    <wai-form-file
      label="{{ 'INTL_DECLARATION_WITH_SIGNATURE' | translate }}"
      [accept]="accept"
      [control]="asFormControl(form.controls.signedDeclaration)"
      [deleteCountdown]="3"
      (fileChange)="onFileChange($event, 'signedDeclaration', form)"
      (fileOpen)="onFileOpen($event)"
    >
    </wai-form-file>
    <wai-form-file
      label="{{ 'INTL_ID_CARD_COPY' | translate }}"
      [accept]="accept"
      [control]="asFormControl(form.controls.idCardScan)"
      [deleteCountdown]="3"
      (fileChange)="onFileChange($event, 'idCardScan', form)"
      (fileOpen)="onFileOpen($event)"
    >
    </wai-form-file>
  </div>
</div>
